import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoChevronDown } from "react-icons/io5";
import { getSessionContext } from "../../common/utils/sessionContext";
import { setManyToLocalStorage } from "../../common/utils/localStorage";
import { getClientsByFamilyMember } from "../../common/api/familyportalOtpApi";
import * as Sentry from "@sentry/react";

const FamilyClientSelect = ({ variant = "header" }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { familyMemberId, familyMemberClientId, familyClientId, familyClientName } = getSessionContext();
  const [selectedClientId, setSelectedClientId] = useState(familyMemberClientId || familyClientId || "");
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setSelectedClientId(familyMemberClientId || familyClientId || "");
  }, [familyMemberClientId, familyClientId]);

  useEffect(() => {
    if (!familyMemberId) {
      setLoading(false);
      return undefined;
    }

    if (Array.isArray(location.state?.clients)) {
      setClients(location.state.clients);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    const fetchClients = async () => {
      setLoading(true);
      try {
        const result = await getClientsByFamilyMember(familyMemberId);
        if (cancelled) {
          return;
        }
        if (result.success && Array.isArray(result.data)) {
          setClients(result.data);
        } else {
          setClients([]);
        }
      } catch (error) {
        Sentry.captureException(error);
        if (!cancelled) {
          setClients([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };
    fetchClients();
    return () => {
      cancelled = true;
    };
  }, [familyMemberId, location.state?.clients]);

  if (loading || clients.length <= 1) {
    return null;
  }

  const handleClientChange = (e) => {
    const clientId = e.target.value;
    const client = clients.find((c) => String(c.clientId) === String(clientId));
    if (!client) return;

    setSelectedClientId(clientId);
    setManyToLocalStorage({
      familyMemberClientId: client.clientId,
      familyClientId: client.clientId,
      familyClientName: client.clientName,
    });
    navigate("/family-home");
  };

  const switcherClass = variant === "hero" ? "family-client-switcher family-client-switcher--hero" : "family-client-switcher";

  return (
    <div className={switcherClass}>
      <span className="family-client-switcher-label">{familyClientName || "Select client"}</span>
      <IoChevronDown className="family-client-switcher-chevron" aria-hidden="true" />
      <select className="family-client-switcher-native" value={selectedClientId} onChange={handleClientChange} aria-label="Switch client">
        {clients.map((client) => (
          <option key={client.clientId} value={client.clientId}>
            {client.clientName}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FamilyClientSelect;
